import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { MCXHeader } from '../mcx-header/mcx-header';

@Component({
  selector: 'app-mcx-samplepage',
  imports: [MCXHeader, CommonModule],
  templateUrl: './mcx-samplepage.html',
  styleUrl: './mcx-samplepage.scss'
})
export class MCXSamplepage {

}
